import {
  Table,
  Tag,
  Typography,
  Image,
  Card,
  Button,
  Popover,
  Modal,
  Form,
  Input,
  message,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  getChecks,
  getPurchaseCategories,
  getRepurchaseV4,
  needCustomerConfirmationV4,
  submitCustomerConfirmationV4,
} from "../api/api";
import moment from "moment";
import { encodeProductCode } from "../utils/Extra";
import { siteInfo } from "../utils/SiteInfo";
import Status from "../components/Status";
import CustomerName from "../components/CustomerName";
import { Link } from "react-router-dom";

const { Text } = Typography;
const { Column } = Table;

export default function RepurchaseV4() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [checks, setChecks] = useState([]);
  const [filter, setFilter] = useState({
    stage: "pending_purchase",
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();

  const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false);
  const [submitConfirmLoading, setSubmitConfirmLoading] = useState(false);
  const [submitForm] = Form.useForm();

  useEffect(() => {
    getPurchaseCategories((cats) => setCategories(cats || []), null);
    getChecks((cks) => setChecks(cks || []), null);
  }, []);

  useEffect(() => {
    setLoading(true);
    getRepurchaseV4((res) => {
      setData(res || []);
      setLoading(false);
    }, filter);
  }, [filter]);

  const showConfirmationModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
    form.resetFields();
  };

  const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!selectedRecord) return;

      setConfirmLoading(true);
      needCustomerConfirmationV4(
        selectedRecord._id,
        { issue: values.issue },
        (res) => {
          setConfirmLoading(false);
          if (res) {
            message.success("Issue submitted successfully");
            setIsModalVisible(false);
            form.resetFields();
            setFilter({ ...filter });
          } else {
            message.error("Failed to submit issue");
          }
        },
      );
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  const showSubmitConfirmationModal = (record) => {
    setSelectedRecord(record);
    setIsSubmitModalVisible(true);
  };

  const handleSubmitModalCancel = () => {
    setIsSubmitModalVisible(false);
    setSelectedRecord(null);
    submitForm.resetFields();
  };

  const handleSubmitModalSubmit = async (action) => {
    try {
      const values = await submitForm.validateFields();
      if (!selectedRecord) return;

      if (!values?.solution) {
        message.error("Please provide a solution");
        return;
      }

      setSubmitConfirmLoading(true);
      submitCustomerConfirmationV4(
        selectedRecord._id,
        { solution: values.solution, decision: action },
        (res) => {
          setSubmitConfirmLoading(false);
          if (res) {
            message.success("Solution submitted successfully");
            setIsSubmitModalVisible(false);
            submitForm.resetFields();
            setFilter({ ...filter });
          } else {
            message.error("Failed to submit solution");
          }
        },
      );
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  const getCheckTitle = (id) => {
    const check = checks.find((ck) => ck._id === id);
    return check?.title || "N/A";
  };

  const getLink = (supplier_purchase_id) => {
    return `https://trade.1688.com/order/new_step_order_detail.htm?orderId=${supplier_purchase_id}`;
  };

  return (
    <div>
      <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
        <Button
          type="primary"
          onClick={() => {
            setFilter({
              stage: "pending_purchase",
            });
          }}
          style={{
            backgroundColor: !filter.method ? siteInfo.navColor : "#fff",
            color: !filter.method ? "#fff" : "#000",
          }}
        >
          All Orders
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setFilter({ ...filter, method: "air" });
          }}
          style={{
            backgroundColor:
              filter.method === "air" ? siteInfo.navColor : "#fff",
            color: filter.method === "air" ? "#fff" : "#000",
          }}
        >
          Air Orders
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setFilter({ ...filter, method: "sea" });
          }}
          style={{
            backgroundColor:
              filter.method === "sea" ? siteInfo.navColor : "#fff",
            color: filter.method === "sea" ? "#fff" : "#000",
          }}
        >
          Sea Orders
        </Button>
      </div>

      {data && (
        <div
          className="mt1 flex"
          style={{
            gap: 16,
          }}
        >
          <Card
            style={{
              width: 280,
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Tag color="magenta">{data?.order_count || 0}</Tag>
              <h3 className="mt05">Total Order</h3>
            </div>
          </Card>
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "16px",
          marginBottom: "16px",
          marginTop: 16,
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setFilter({ ...filter, stage: "pending_purchase" });
          }}
          style={{
            backgroundColor:
              filter.stage === "pending_purchase" ? siteInfo.navColor : "#fff",
            color: filter.stage === "pending_purchase" ? "#fff" : "#000",
          }}
        >
          Pending Purchase
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setFilter({ ...filter, stage: "need_confirmation" });
          }}
          style={{
            backgroundColor:
              filter.stage === "need_confirmation" ? siteInfo.navColor : "#fff",
            color: filter.stage === "need_confirmation" ? "#fff" : "#000",
          }}
        >
          Pending Customer Confirmation
        </Button>
        <Button
          type="primary"
          onClick={() => {
            const newFilter = { ...filter };
            delete newFilter.stage;
            setFilter(newFilter);
          }}
          style={{
            backgroundColor: !filter.stage ? siteInfo.navColor : "#fff",
            color: !filter.stage ? "#fff" : "#000",
          }}
        >
          All
        </Button>
      </div>

      <Table
        dataSource={data?.orders}
        rowKey={(record) => record._id}
        loading={loading}
        bordered
        pagination={{ pageSize: 50 }}
      >
        <Column
          title="Order"
          key="code"
          render={(text, record) => (
            <div>
              <div className="flex alignCenter mb1">
                <Image
                  src={record.product?.image}
                  alt="product"
                  width={55}
                  height={55}
                  style={{ objectFit: "cover" }}
                />
                <div className="mt05">
                  <a
                    href={
                      record?.product?.code?.includes("abb-")
                        ? `https://skybuybd.com/product/${encodeProductCode(
                            record?.product?.code,
                          )}`
                        : `https://skyone.global/product/${encodeProductCode(
                            record?.product?.code,
                          )}`
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="link">Link</Button>
                  </a>
                </div>
              </div>
              <Link
                to={`/order/${record.code}`}
                style={{ fontWeight: 500, margin: 0 }}
              >
                #{record.code || record._id}
              </Link>
              <p style={{ fontSize: 12 }}>
                {moment(record.createdAt).format("DD MMM, YYYY")}
              </p>
            </div>
          )}
        />
        <Column
          title="Customer"
          key="phone"
          render={(text, record) => <CustomerName data={record.customer} />}
        />

        <Column
          title="Weight"
          align="center"
          key="weight"
          render={(text, record) => (
            <Text>{record?.product?.weight ? record.product.weight : "-"}</Text>
          )}
        />
        <Column
          title="Price"
          align="center"
          key="grand_total"
          render={(text, record) => <Text>৳{record.grand_total}</Text>}
        />
        <Column
          title="Supplier Order ID"
          key="title"
          width={300}
          render={(text, record) => (
            <div>
              {record.purchase?.supplier_order_id ? (
                <a
                  href={getLink(record.purchase?.supplier_order_id)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Tag color="green" style={{ fontSize: "11px" }}>
                    {record.purchase?.supplier_order_id}
                  </Tag>
                </a>
              ) : (
                "--"
              )}
            </div>
          )}
        />
        <Column
          title="Shipment"
          key="details"
          render={(text, record) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Status name={record?.shipment?.method} />
              </div>
              <div>
                <Status name={record.shipment?.route} />
              </div>
              <div>
                <Tag>Charge {record.shipment?.charge || ""}</Tag>
              </div>
              <div>
                <Tag color="volcano">
                  Belt Lot {record?.shipment?.belt_lot || "-"}
                </Tag>
              </div>
            </div>
          )}
        />
        <Column
          title="Checks"
          key="shipment"
          render={(text, record) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              {record.product?.checks?.map((check, index) => (
                <p key={check}>
                  {index + 1}. {getCheckTitle(check)}
                </p>
              ))}
            </div>
          )}
        />
        <Column
          title="Issue"
          align="center"
          key="grand_total"
          render={(text, record) => (
            <Popover
              content={
                <div style={{ maxWidth: 300 }}>
                  <p>{record?.purchase?.issue}</p>
                </div>
              }
              title="Issue"
              trigger="hover"
            >
              {record?.purchase?.issue
                ? record?.purchase?.issue?.slice(0, 10) + "..."
                : ""}
            </Popover>
          )}
        />
        {filter.stage !== "need_confirmation" && (
          <Column
            title="Solution"
            align="center"
            key="grand_total"
            render={(text, record) => (
              <Popover
                content={
                  <div style={{ maxWidth: 300 }}>
                    <p>{record?.purchase?.solution}</p>
                  </div>
                }
                title="Solution"
                trigger="hover"
              >
                {record?.purchase?.solution
                  ? record?.purchase?.solution?.slice(0, 10) + "..."
                  : ""}
              </Popover>
            )}
          />
        )}
        <Column
          title="SkyShip Note"
          align="center"
          key="grand_total"
          render={(text, record) => (
            <Popover
              content={
                <div style={{ maxWidth: 300 }}>
                  <p>{record?.product?.note}</p>
                </div>
              }
              title="SkyShip Note"
              trigger="hover"
            >
              {record?.product?.note
                ? record?.product?.note?.slice(0, 10) + "..."
                : "N/A"}
            </Popover>
          )}
        />
        <Column
          title="Action"
          align="center"
          key="action"
          render={(text, record) => (
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {filter.stage === "pending_purchase" && (
                <Button
                  type="primary"
                  onClick={() => showConfirmationModal(record)}
                >
                  Customer Confirmation
                </Button>
              )}
              {filter.stage === "need_confirmation" && (
                <>
                  <Button
                    type="primary"
                    style={{
                      background: "#9E3B3B",
                    }}
                    onClick={() => showSubmitConfirmationModal(record)}
                  >
                    Submit Confirmation
                  </Button>
                </>
              )}
            </div>
          )}
        />
      </Table>

      <Modal
        title="Need Customer Confirmation"
        visible={isModalVisible}
        onOk={handleModalSubmit}
        onCancel={handleModalCancel}
        confirmLoading={confirmLoading}
        okText="Submit"
      >
        <Form
          form={form}
          layout="vertical"
          style={{
            marginTop: 16,
          }}
        >
          <Form.Item
            name="issue"
            label="Issue details"
            rules={[{ required: true, message: "Please input the issue!" }]}
          >
            <Input.TextArea rows={4} placeholder="Describe the issue here..." />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Submit Confirmation"
        visible={isSubmitModalVisible}
        onCancel={handleSubmitModalCancel}
        confirmLoading={submitConfirmLoading}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              key="refund"
              type="primary"
              loading={submitConfirmLoading}
              onClick={() => handleSubmitModalSubmit("refund")}
              style={{
                background: "#C00707",
              }}
            >
              Refund
            </Button>
            <Button
              key="continue"
              type="primary"
              loading={submitConfirmLoading}
              onClick={() => handleSubmitModalSubmit("continue")}
            >
              Continue
            </Button>
          </div>,
        ]}
      >
        <Form
          form={submitForm}
          layout="vertical"
          style={{
            marginTop: 16,
          }}
        >
          <Form.Item
            name="solution"
            label="Solution"
            rules={[{ required: true, message: "Please input the solution!" }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Describe the solution here..."
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
